import { Flex } from '@banhala/ui-kit';
import { DeliveryBadgeRow } from './DeliveryBadgeRow';
import { TitleContent } from './TitleContent';

export const ThirdPLDeliverySection = () => {
  return (
    <TitleContent title={'배송정보'}>
      <Flex gap={4}>
        <Flex.Row gap={8} alignItems={'center'}>
          <DeliveryBadgeRow testID={'도착보장툴팁'} />
        </Flex.Row>
      </Flex>
    </TitleContent>
  );
};
